import { render } from "./DeleteStudy.vue?vue&type=template&id=75c72e29&scoped=true"
import script from "./DeleteStudy.vue?vue&type=script&lang=js"
export * from "./DeleteStudy.vue?vue&type=script&lang=js"

import "../css/DeletingList.css?vue&type=style&index=0&id=75c72e29&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c72e29"]])

export default __exports__